<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>

    <BannerPopup></BannerPopup>

    <!-- swiper 轮播 -->
    <!-- <div class="banner_wrap">
      <el-carousel :autoplay="false" trigger="click">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index" ref="bannerItemRef">
            <img :src="item" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="banner-swiper">
      <!-- Swiper -->
      <div class="swiper-container swiper banner-container">
        <div class="swiper-wrapper">
          <template v-if="bannerList && bannerList.length > 0">
            <div class="swiper-slide" style="width: 100%;">
              <video src="../../assets/images/home/banner.mp4" style="width:100%;" autoplay muted loop></video>
            </div>
            <div class="swiper-slide" v-for="(item, i) in bannerList" :key="i" style="width:100%;">
              <!-- <el-image :src="item" fit="cover"></el-image> -->
              <img :src="item" alt="" />
            </div>
          </template>
          <div class="swiper-slide" style="width:100%;" v-else>
            <el-image>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <!-- 我们是谁？ -->
    <div class="about_wrap animated fadeInUp">
      <div class="about_title title-common">{{ homePageLang.titleOne }}</div>
      <div class="about_introductior">
        {{ homePageLang.contentOne }}
      </div>
      <ul class="nav_wrap">
        <li v-for="(item, index) in aboutList" :key="index">
          <img :src="item.imgsrc" alt="" class="about_img" />
          <p class="list_name">{{ item.name }}</p>
          <p class="list_introductior">{{ item.introductior }}</p>
        </li>
      </ul>
      <a href="#/about">
        <div class="dynamic_btn">
          <span>MORE</span>
          <img
            class="more_btn"
            src="../../assets/images/public/arrow1.png"
            alt=""
          />
        </div>
      </a>
    </div>
    <!-- KELK主要行业 -->
    <div class="main_wrap active animated fadeInUp">
      <div class="main_top">
        <h2 class="title-common">{{ homePageLang.titleTwo }}</h2>
        <div v-html="$convertPxToRem(homePageLang.contentTwo)"></div>
        <a href="#/yyly">
          <div class="dynamic_btn">
            <span>MORE</span>
            <img
              class="more_btn"
              src="../../assets/images/public/arrow1.png"
              alt=""
            />
          </div>
        </a>
      </div>
      <ul class="hy_icon_ul">
        <li class="" v-for="(x, index) in appList" :key="index">
          <a :href="`#/yyly?index=${index}&detailsId=${x.id}&label=${x.cate_name}`">
            <div class="sy_top">
              <span
                :style="
                  'background: url(' + x.full_ico_image + ') no-repeat center'
                "
              ></span>
              <p>{{ x[`${currentLang.prefix}cate_name`] }}</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <!-- 我们的能力 -->
    <div class="ability_wrap animated fadeInUp">
      <div class="ability_block">
        <div class="ability_title">{{ homePageLang.titleThree }}</div>
        <ul class="ul_wrap">
          <img src="../../assets/images1/i2.png" class="ab_mid" />
          <li
            v-for="(item, index) in abilityList"
            :key="index"
            @mouseenter="onMouseOver(item.id)"
            @click="toAbility"
          >
            <img
              v-show="bgIndex === item.id ? true : false"
              src="../../assets/images1/bg3.png"
              class="ab_bg"
            />
            <img :src="item.imgsrc" class="ab_logo" />
            <div class="ability_content">
              <p class="ability_name">{{ item.name }}</p>
              <p class="ability_english">{{ item.english }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 我们的动态 -->
    <!-- <div class="dynamic_wrap animated fadeInUp">
      <div class="dynamic_block">
        <div class="dynamic_title">{{ homePageLang.titleFour }}</div>
        <ul class="dynamic_nav">
          <li v-for="(item, index) in newsList" :key="index">
            <img :src="item.image" alt="" class="dynamic_img" />
            <div class="dynamic_content">
              <p class="dynamic_name">
                {{ item[`${currentLang.prefix}title`] }}
              </p>
              <p class="dynamic_time">
                <span>{{ item.time }}</span>
                <span>{{ item.type }}</span>
              </p>
              <div class="dynamic_btn" @click="goNdetail(item.id)">
                <span>MORE</span>
                <img
                  class="more_btn"
                  src="../../assets/images/public/arrow1.png"
                  alt=""
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div> -->
    <div class="dynamic_wrap animated fadeInUp">
      <div class="dynamic_block">
        <div class="dynamic_title">{{ homePageLang.titleFour }}</div>
        <div class="dynamic_box">
          <div class="swiper_toggle_btn swiper_toggle_btn-left" @click="onToggle('prev')">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="swiper-container swiper news-swiper-container">
            <ul class="dynamic_nav swiper-wrapper">
              <li v-for="(item, index) in newsList" :key="index" class="swiper-slide news-item" @click="goNdetail(item.id)">
                <img :src="item.image" alt="" class="dynamic_img" />
                <div class="dynamic_content">
                  <p class="dynamic_name">
                    {{ item[`${currentLang.prefix}title`] }}
                  </p>
                  <p class="dynamic_time">
                    <span>{{ item.publish_time_txt && item.publish_time_txt.length > 0 ? item.publish_time_txt.split(' ')[0] : '' }}</span>
                  </p>
                  <!-- <div class="dynamic_btn" @click="goNdetail(item.id)">
                    <span>MORE</span>
                    <img
                      class="more_btn"
                      src="../../assets/images/public/arrow1.png"
                      alt=""
                    />
                  </div> -->
                </div>
              </li>
            </ul>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
          </div>
          <div class="swiper_toggle_btn swiper_toggle_btn-right" @click="onToggle('next')">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 我们的故事 -->
    <div class="story_wrap1">
      <div class="story_title">{{ homePageLang.titleFive }}</div>
      <div class="story_content">
        <div class="story_line"></div>
        <div class="story_box">
          <div class="story_main_top story_main">
            <template v-for="(item, index) in articleList">
              <template v-if="index % 2 === 0">
                <div class="story_body" :key="index">
                  <div class="story_year">
                    {{ item[`${currentLang.prefix}title`] }}
                  </div>
                  <div
                    class="story_body_content"
                    v-html="$convertPxToRem(removeHtmlStyle(item[`${currentLang.prefix}content`]))"
                  ></div>
                  <div class="story_content_line"></div>
                  <div class="story_dots"></div>
                </div>
              </template>
            </template>
          </div>
          <div class="story_main_bottom story_main">
            <template v-for="(item, index) in articleList">
              <template v-if="index % 2 === 1">
                <div class="story_body" :key="index">
                  <div class="story_dots"></div>
                  <div class="story_content_line"></div>
                  <div class="story_content_main">
                    <div class="story_year">
                      {{ item[`${currentLang.prefix}title`] }}
                    </div>
                    <div
                      class="story_body_content"
                      v-html="
                        $convertPxToRem(removeHtmlStyle(item[`${currentLang.prefix}content`]))
                      "
                    ></div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="number_wrap animated fadeInUp"
      :style="{ backgroundImage: `url(${historyForSummarize.bgImgSrc})` }"
    >
      <template v-for="(item,index) in historyForSummarize.children">
        <div :key="index" class="number-wrap__item">
          <div class="number-wrap__icon">
            <img :src="item.iconSrc" style="width:100%;height:100%;" />
          </div>
          <div class="number-wrap__subTitle">{{ item.subTitle }}</div>
          <div class="number-wrap__title">{{ item.title }}</div>
        </div>
        <div
          :key="index + historyForSummarize.bgImgSrc.length"
          class="number-wrap__line"
          :class="currentLang.value == 'zh-CN' ? 'number-wrap__line2' : ''"
          v-if="index < (historyForSummarize.children.length - 1)"
        >
        </div>
      </template>
    </div>
    <!-- 我们的客户 -->
    <div class="cus_wrap animated fadeInUp">
      <div class="wrap_title">{{ homePageLang.titleSix }}</div>
      <div class="cus_logo-list" v-if="commonData.mycustom_image">
        <div class="cus_logo-item" v-for="(img, index) in commonData.mycustom_image" :key="index">
          <img :src="img" />
        </div>
      </div>
      <ul v-if="commonData[`${currentLang.prefix}mycustom_name`]">
        <li v-for="(value, key) in commonData[`${currentLang.prefix}mycustom_name`]" :key="key">
          <span class="cus_title">{{ key }}:</span>
          <div class="cus_con">{{ value }}</div>
        </li>
      </ul>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>


<script>
import BannerPopup from './modules/BannerPopup.vue'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import {
  getCateListApplication,
  getCaseList,
  getConfigDataApi,
  getArticleList
} from "@/utils/http.js";
import { mapGetters } from "vuex";


export default {
  components: {
    BannerPopup
  },

  data() {
    return {
      newsList: [],
      newsSwiper: null,
      isShowNewsBanner: true,
      bgShow: false,
      bgIndex: 0,
      appList: [],
      bannerList: [],
      articleList: [],
      commonData: {},
      timer: null
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    aboutPageLang() {
      return this.currentLang.config.aboutPage;
    },
    homePageLang() {
      return this.currentLang.config.homePage;
    },
    aboutList() {
      return this.currentLang.config.homePage.aboutList;
    },
    abilityList() {
      return this.currentLang.config.homePage.abilityList;
    },
    historyForSummarize() {
      return this.currentLang.config.homePage.historyForSummarize;
    },
  },

  created() {
    this.fetchCommonData();
    this.getAppList();
    this.getNewList();
    this.getArticle();
  },

  mounted() {
    
  },

  methods: {
    onToggle(flag) {
      switch(flag) {
        case 'prev':
          this.newsSwiper && this.newsSwiper.slidePrev()
          break
        case 'next':
          this.newsSwiper && this.newsSwiper.slideNext()
          break
      }
    },

    // 初始化 banner swiper
    initBannerSwiper() {
      const bannerSwiper = new Swiper(".banner-container", {
        autoplay: {
          delay: 6000,
        },
        speed: 1100,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    },

    // 初始化 news swiper
    initNewsSwiper() {
      const _this = this
      this.newsSwiper = new Swiper(".news-swiper-container", {
        slidesPerView: 3,
        spaceBetween: 25,
       /*  pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
          },
        }, */
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        resizeObserver: true,
        on: {
          resize() {
            if (_this.timer) {
              clearTimeout(_this.timer)
              _this.timer = null
            }
            this.timer = setTimeout(() => {
              _this.$nextTick(() => {
                _this.newsSwiper && _this.newsSwiper.update()
                console.log('123123')
              })
            }, 150)
          }
        }
      });
    },


    fetchCommonData() {
      getConfigDataApi().then(result => {
        if (result.code == 1) {
          this.commonData = result.data
          this.bannerList = result.data[`${this.currentLang.prefix}banner_index`];
          this.$nextTick(() => {
            setTimeout(() => {
              this.initBannerSwiper();
            })
          })
        }
      })
    },
    
    goNdetail(id) {
      this.$router.push({
        path: "/nText",
        query: { id: id, activeNameText: this.activeNameText }
      });
    },
    getNewList() {
      getCaseList({
        cate_id: 10,
        page: 1,
        limit: 10
      }).then(res => {
        if (res.code === 1) {
          this.newsList = res.data.list;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.initNewsSwiper();
          })
        })
      });
    },
    getAppList() {
      getCateListApplication().then(res => {
        if (res.code === 1) {
          this.appList = res.data;
        }
      });
    },
    onMouseOver(id) {
      this.bgIndex = id;
    },
    toAbility() {
      this.$router.push({ path: "/about", query: { index: 4 } });
    },
    getArticle() {
      getArticleList({
        cate_id: 93,
        limit: 50
      }).then(res => {
        console.log("getArticleList", res);
        if (res.code === 1) {
          this.articleList = res.data.list;
        }
      });
    },
    removeHtmlStyle(html) {
      let rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/g;
      let newHtml = "";
      if (html) {
        newHtml = html.replace(rel, "");
      }
      // 清除类名
      // let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;
      // let newClassHtml = "";
      // if (newHtml) {
      //   newClassHtml = newHtml.replace(relClass, "");
      // }
      return newHtml;
    }
  },

  watch: {
    
  },

  beforeDestroy() {
    this.newsSwiper && this.newsSwiper.destroy()
  }
};
</script>


<style lang="scss" scoped>
.banner_wrap {
  width: 100%;
  height: auto;

  .el-carousel {
    width: 100%;
    height: 630px;

    /deep/ .el-carousel__container {
      height: 100%;

      img {
        width: 100%;
        height: auto;
        height: 100%;
      }
    }
  }
}

.banner-swiper {
  // min-height: 400px;
  width: 100%;
  // transition: all 5s;

  .swiper-container {
    // height: 100%;
    width: 100%;
  }
  
  .swiper-wrapper {
    width: 100%;
    // height: 100%;
    // transform: translate3d(0, 0px, 0px);
    // transition-timing-function: linear;
  }

  .swiper-slide {
    width: 100%;
    // height: 100%;
  }

  .swiper-slide-item {
    width: 100%;
    // display: inline-block;
    // box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.2);
  }

  img {
    width: 100%;
  }

  .swiper-button-next, .swiper-button-prev {
    color: rgba(0, 0, 0, 0.8);
  }
  
  .swiper-pagination-bullet-active {
    background: var(--main-color)!important;
  } 
}

.about_wrap {
  width: 1200px;
  height: auto;
  margin: 100px auto 0;

  .about_title {
    font-size: 34px;
    color: #333;
    text-align: center;
  }

  .about_introductior {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-top: 32px;
  }

  .nav_wrap {
    margin-top: 70px;
    display: flex;
    justify-content: space-between;

    li {
      img {
        width: 250px;
        height: auto;
        margin: 0 auto;
        display: block;
      }

      .list_name {
        font-size: 22px;
        color: var(--main-color-blue);
        margin-top: 60px;
        text-align: center;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .list_introductior {
        width: 250px;
        font-size: 14px;
        font-size: 16px;
        color: #333;
        margin: auto;
        margin-top: 24px;
        text-align: center;
        text-align: justify;
        text-align-last: center;
      }
    }
  }
  .dynamic_btn {
    width: 130px;
    height: 40px;
    background: #e8363e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin: 40px auto 0 auto;
    cursor: pointer;
    .more_btn {
      width: 40px;
      margin-left: 10px;
    }
  }
}

.title-common {
  
  font-size: 40px!important;
  font-weight: bold!important;
  color: black;
  text-align: center!important;
}

.main_wrap {
  width: 100%;
  height: auto;
  background: url(../../assets/images1/i1.jpg) no-repeat;
  background-size: 100% 100%;
  margin-top: 65px;
  position: relative;

  .main_top {
    color: #fff;
    padding-top: 100px;
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    h2 {
      font-size: 30px;
      font-weight: normal;
      color: #fff;
    }
    div {
      // text-indent: 2em;
      font-size: 20px;
      font-weight: 500;
      margin-top: 32px;
      line-height: 30px;
      color: rgba($color: #fff, $alpha: 0.9);
    }
    .dynamic_btn {
      width: 130px;
      height: 40px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 40px auto 0 auto;
      cursor: pointer;
      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }
  .hy_icon_ul {
    li {
      width: 11%;
      background: #efefef;
      text-align: center;
      display: inline-block;
      box-sizing: border-box;
      float: left;
      vertical-align: top;
      height: 100%;
      transform: translateY(100px);
      opacity: 0;
      transition: all 1.5s cubic-bezier(0.35, 0.75, 0.55, 1);
      -webkit-transition: all 1.5s cubic-bezier(0.35, 0.75, 0.55, 1);
      -moz-transition: all 1.5s cubic-bezier(0.35, 0.75, 0.55, 1);
      a {
        display: block;
        height: 100%;
      }
    }
  }
}

.main_wrap.active .hy_icon_ul li {
  transform: translateY(67px);
  opacity: 1;
}

.main_wrap .hy_icon_ul li:hover a {
  background: #1991d6;
}

.main_wrap .hy_icon_ul li.li_col {
  background: #e2e2e2;
}

.main_wrap .hy_icon_ul li p {
  color: #969696;
  font-size: 18px;
  margin-top: 18px;
}

.main_wrap .hy_icon_ul li:hover p {
  color: #fff;
}

.main_wrap .hy_icon_ul li span {
  width: 110px;
  height: 81px;
  display: inline-block;
  margin-top: 28px;
}

.hy_icon_ul li .sy_top span {
  background: url(../../assets/images1/hy1.png) no-repeat center;
}

.hy_icon_ul li:first-child + li .sy_top span {
  background: url(../../assets/images1/hy2.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li .sy_top span {
  background: url(../../assets/images1/hy3.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li .sy_top span {
  background: url(../../assets/images1/hy4.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li + li .sy_top span {
  background: url(../../assets/images1/hy5.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li + li + li .sy_top span {
  background: url(../../assets/images1/hy6.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li + li + li + li .sy_top span {
  background: url(../../assets/images1/hy7.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li + li + li + li + li .sy_top span {
  background: url(../../assets/images1/hy8.png) no-repeat center;
}

.hy_icon_ul li:hover .sy_top span {
  background: url(../../assets/images1/hy11.png) no-repeat center;
}

.hy_icon_ul li:first-child + li:hover .sy_top span {
  background: url(../../assets/images1/hy22.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li:hover .sy_top span {
  background: url(../../assets/images1/hy33.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li:hover .sy_top span {
  background: url(../../assets/images1/hy44.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li + li:hover .sy_top span {
  background: url(../../assets/images1/hy55.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li + li + li:hover .sy_top span {
  background: url(../../assets/images1/hy66.png) no-repeat center;
}

.hy_icon_ul li:first-child + li + li + li + li + li + li:hover .sy_top span {
  background: url(../../assets/images1/hy77.png) no-repeat center;
}

.hy_icon_ul
  li:first-child
  + li
  + li
  + li
  + li
  + li
  + li
  + li:hover
  .sy_top
  span {
  // background: url(../../assets/images1/hy88.png) no-repeat center;
}

.hy_icon_ul li:hover .sy_top {
  transform: translateY(-70px);
  filter: progid:DXImageTransform.Microsoft.Matrix(M11=cos(360), M12=-sin(360), M21=sin(360), M22=cos(360), SizingMethod='auto expand');
  -ms-transform: translateY(-70px);
  -moz-transform: translateY(-70px);
  -webkit-transform: translateY(-70px);
  -o-transform: translateY(-70px);
  background: #003359;
  background: rgb(55, 101, 149);
  padding-top: 20px;
  padding-bottom: 40px;
  height: 186px;
}

.hy_icon_ul li .sy_top {
  height: 215px;
  transition: 0.3s ease-in-out;
}

.hy_icon_ul li:hover .sy_top {
  transform: translateY(-37px);
  padding-bottom: 0;
}

.main_wrap ul {
  height: auto;
  overflow: hidden;
}

.main_wrap.active .hy_icon_ul li {
  width: 12.5%;
  border-bottom: 1px solid #ccc;
}

.main_wrap .hy_icon_ul li span {
  margin-top: 20px;
}

.main_wrap .hy_icon_ul li p {
  font-size: 16px;
}

.hy_icon_ul li:nth-child(1) .sy_top span {
  background-size: 70%;
}

.hy_icon_ul li:nth-child(2) .sy_top span {
  background-size: 70%;
}

.hy_icon_ul li:nth-child(3) .sy_top span {
  background-size: 70%;
}

.hy_icon_ul li:nth-child(4) .sy_top span {
  background-size: 70%;
}

.hy_icon_ul li:nth-child(5) .sy_top span {
  background-size: 70%;
}

.hy_icon_ul li:nth-child(6) .sy_top span {
  background-size: 70%;
}

.hy_icon_ul li:nth-child(7) .sy_top span {
  background-size: 70%;
}

.hy_icon_ul li:nth-child(8) .sy_top span {
  background-size: 70%;
}

.main_wrap .hy_icon_ul li p {
  margin-top: 0;
  margin-bottom: 20px;
}

// .hy_icon_ul li:hover .sy_top {
//   display: none;
// }

.main_wrap .hy_icon_ul {
  width: 1200px;
  margin: 80px auto 0 auto;
}

.main_wrap .hy_icon_ul li:hover a {
  background: none;
}

.main_wrap.active .hy_icon_ul li {
  border-bottom: 1px solid #d8d7d7;
}

.ability_wrap {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 631px;
  // background: url(../../assets/images1/bg1.png) no-repeat;
  // background-size: 100% 100%;
  background: white;
  margin-top: 100px;
  position: relative;

  .ability_img {
    width: 538px;
    position: absolute;
    top: 0;
    right: 37px;
  }

  .ability_block {
    // margin-left: 300px;
    display: inline-block;

    .ability_title {
      font-size: 40px;
      font-weight: bold;
      color: black;
      text-align: center;
    }

    .ul_wrap {
      width: 1350px;
      height: 380px;
      // background-color:red;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      margin-top: 40px;
      position: relative;
      .ab_mid {
        width: 420px;
        height: 380px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
      }
      li:nth-child(2n + 1) {
        margin-left: 350px;
      }
      li {
        width: 430px;
        height: 161px;
        // background: url(../../assets/images1/bg3.png) no-repeat;
        background-size: 100% 100%;
        margin-bottom: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .ab_bg {
          width: 430px;
          height: 161px;
          // box-shadow:10px 0px 10px 0px rgba(0,0,0,0.8);
        }
        .ab_logo {
          width: 70px;
          height: 70px;
          margin-left: 30px;
          margin-right: 20px;
          position: absolute;
        }

        .ability_content {
          cursor: pointer;
          position: absolute;
          left: 120px;
          left: 110px;
          .ability_name {
            font-size: 28px;
            color: #000;
            font-weight: bold;
          }

          .ability_english {
            font-size: 18px;
            font-family: Roboto;
            color: #666;
            margin-top: 5px;
          }
        }
      }
    }
  }
}

.dynamic_wrap {
  width: 100%;
  height: 780px;
  background: #f5f5f5;
  display: inline-block;

  .news-item {
    cursor: pointer;
    transition: all 0.4s;
  }

  .news-item:hover {
    
    transform: scale(1.05);
    box-shadow: 0 0 20PX 0PX rgba(0,0,0,0.3);
  }

  .dynamic_block {
    width: 1200px;
    width: 100%;
    height: 100%;
    margin: 0 auto;

    .dynamic_title {
      font-size: 40px;
      font-weight: bold;
      color: #333;
      margin-top: 100px;
      text-align: center;
    }

    .dynamic_box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: auto;
      position: relative;
    }
    
    .news-swiper-container {
      width: 1200px;
    }
    
    .swiper-container {
      margin-left: 0;
      margin-right: 0;
    }

    .swiper_toggle_btn {
      // position: absolute;
      // top: 50%;
      // transform: translateY(-50%);
      width: 40px;
      height: 60px;
      font-size: 45px;
      text-align: center;
      line-height: 60px;
      cursor: pointer;
    }

    .swiper_toggle_btn .el-icon-arrow-right,
    .swiper_toggle_btn .el-icon-arrow-left {
      font-weight: 700;
      color: var(--main-color-blue);
    }

    .swiper_toggle_btn-left {
      // left: 5px;
      margin-right: 5px;
    }
    .swiper_toggle_btn-right {
      // right: 5px;
      // margin-left: 5px;
    }

    .dynamic_nav {
      margin-top: 48px;
      padding: 10px;
      padding-bottom: 40px;

      li {
        width: 380px;
        background: #fff;
        overflow: hidden;

        .dynamic_img {
          width: 100%;
          height: 280px;
          height: 290px;
          object-fit: cover;
        }

        .dynamic_content {
          padding: 20px 30px 20px;
          background: #fff;

          .dynamic_name {
            height: 95px;
            font-size: 20px;
            text-align: justify;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }

          .dynamic_time {
            margin-top: 15px;
            font-size: 19px;
            

            span:first-child {
              color: #999;
            }

            span:last-child {
              color: #003359;
              // font-size: 14px;
              // margin-left: 10px;
            }
          }

          .dynamic_btn {
            width: 140px;
            height: 45px;
            margin: 25px auto 0;
            background: #e8363e;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            .more_btn {
              width: 40px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
}
.story_wrap1 {
  margin-top: 100px;
  background: #fff;
  .story_title {
    font-size: 40px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }
  .story_content {
    margin-top: 40px;
    height: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  .story_line {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    width: 100%;
    height: 5px;
    background: #e01a21;
  }

  .story_box {
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    height: 100%;
    width: auto;
    max-width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
  }

  .story_main {
    margin: auto;
    height: 50%;
    display: flex;
    position: relative;
  }

  .story_main_top {
    padding-left: 50px;
    .story_body {
      width: 290px;
      min-width: 290px;
      max-width: 290px;
      height: 100%;
      position: relative;
      .story_dots {
        width: 12px;
        height: 12px;
        background: #fff;
        border: 7px solid #000;
        border-radius: 50%;
        position: absolute;
        bottom: -14px;
        left: 0;
        z-index: 1;
      }
      .story_content_line {
        width: 3px;
        height: 53px;
        background: #434343;
        margin-left: 11px;
        position: absolute;
        bottom: 10px;
        left: 0;
      }
      .story_year {
        font-size: 35px;
        position: absolute;
        top: 0;
        left: 0;
      }
      .story_body_content {
        width: 245px !important;
        color: #000 !important;
        background: #fff;
        line-height: 1.3;
        text-align: justify;
        position: absolute;
        top: 60px;
        left: 0;
        z-index: 2;
      }
    }
  }
  .story_main_bottom {
    padding-left: 100px;
    .story_body {
      width: 290px;
      min-width: 290px;
      max-width: 290px;
      height: 100%;
      position: relative;
      .story_dots {
        width: 12px;
        height: 12px;
        background: #fff;
        border: 7px solid #000;
        border-radius: 50%;
        position: absolute;
        top: -11.5px;
        left: 0;
      }
      .story_content_line {
        width: 3px;
        height: 53px;
        background: #434343;
        margin-left: 11px;
        position: absolute;
        top: 13px;
        left: 0;
      }
      .story_content_main {
        width: 245px !important;
        background: #fff;
        position: absolute;
        top: 40px;
        left: 0;
        z-index: 2;
      }
      .story_body_content {
        color: #000 !important;
        line-height: 1.3;
        text-align: justify;
      }
      .story_year {
        font-size: 35px;
        // position: absolute;
        // bottom: 0;
        // left: 0;
      }
    }
  }
}
.story_wrap {
  .story_img {
    width: 100%;
    height: auto;
  }
}

.number_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 240px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 50px;
  color: #fff;

  .number-wrap__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .number-wrap__line {
    height: 80px;
    width: 2px;
    margin: 0 70px;
    border-radius: 2px;
    background-color: rgba(255,255,255,0.3);
  }

  .number-wrap__line2 {
    margin: 0 120px;
  }

  .number-wrap__icon {
    width: 66px;
    height: 66px;
  }

  .number-wrap__subTitle {
    margin: 8px 0 4px;
    font-size: 34px;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .number-wrap__title {
    font-size: 20px;
    color: rgba(255,255,255,0.9);
    letter-spacing: 2px;
  }
}

.cus_wrap {
  width: 100%;
  max-width: 1400px;
  margin: auto;
  // min-height: 600px;
  // background: url(../../assets/images1/bg5.jpg) no-repeat;
  // background-size: 100% 100%;
  padding-top: 1px;
  .wrap_title {
    font-size: 40px;
    font-weight: bold;
    color: #333;
    text-align: center;
    margin-top: 100px;
    margin-bottom: 70px;
  }
  

  .cus_logo-list {
    margin: auto;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
  }

  .cus_logo-item {
    width: 120px;
    margin: 16px;
    margin: 10px;
  }

  .cus_logo-item img {
    width: 100%;
    object-fit: cover;
  }

  ul {
    width: 1000px;
    margin: 70px auto 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  li {
    display: flex;
    font-size: 14px;
    font-size: 16px;
    margin-top: 20px;
  }
  .cus_title {
    width: 72px;
    text-align: right;
  }
  .cus_con {
    width: 400px;
    margin-left: 20px;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
}

</style>

<style scoped>
.news-swiper-container .swiper-button-next,
.news-swiper-container .swiper-button-prev {
  color: #000;
}

.swiper-container-horizontal>.swiper-pagination-progressbar {
  top: auto;
  bottom: 0;
}
</style>

<style>
.news-swiper-container .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background-color: var(--main-color); 
}

.news-swiper-container .swiper-pagination-bullet {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color:#000;
  opacity: 1;
  background: rgba(0,0,0,0.1);
}
.news-swiper-container .swiper-pagination-bullet-active {
  color:#fff;
  background: var(--main-color);
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue